export const BLOGS = "blogs";
export const COMMENTS = "comments";